// extracted by mini-css-extract-plugin
export default {"greeting":"front-page_greeting__UkwEb","welcome":"front-page_welcome__dDG7z","locationContainer":"front-page_locationContainer__HiQGT"};